<template>
  <li class="listitem">
      <div class="left">
          <img src="../../assets/img/listpic.png" alt="">
      </div>
      <div class="right">
          <h2>
            <a href="javascript:;" @click="orderDetail">订单编号:{{order.code}}</a><span class="pay">{{order.paystatus === 'y' ? '已支付' : '未支付'}}</span><span class="pay">支付方式：{{payType()}}</span>
            <router-link target="_blank" class="comment" :to="{name:'comment',query:{id: order.id}}" v-if="order.paystatus === 'y'">
                {{order.closedComment === 'y' ? '已评价' : '去评价'}}
            </router-link>
            <router-link target="_blank" class="comment" :to="{name:'orderPay',query:{id: order.id}}" v-else>去支付</router-link>
          </h2>
          <p class="orderdate"><span>订单日期 : {{order.createdate}}</span><span>订单金额 : {{order.totalMoney}}</span><span>交付方式 : {{deliveryType()}}</span></p>
          <p class="text">购买产品种类 : <span>{{order.catalogs}}</span>  总交付面积 : <span>{{order.area}}</span>  使用代金券金额  :  <span>{{order.voucherAmount}}</span><span class="look"><a href="javascript:;" @click="orderDetail">查看订单</a></span></p>
      </div>
  </li>
</template>

<script>
export default {
  name: '',
  props: ['order'],
  data () {
    return {

    }
  },
  methods: {
    payType() {
      if (this.order.payType === 'zhifubao') {
        return '支付宝'
      } else if (this.order.payType === 'daijinquan') {
        return '代金券'
      } else if (this.order.payType === 'weixin') {
        return '微信'
      } else {
        return '无'
      }
    },
    deliveryType() {
      if (this.order.deliveryType === '0') {
        return '云盘'
      } else if (this.order.deliveryType === '1') {
        return 'FTP'
      } else if (this.order.deliveryType === '2') {
        return '离线硬盘'
      } else if (this.order.deliveryType === '3') {
        return '服务器接收'
      } else {
        return '未交付'
      }
    },
    orderDetail() {
      this.$router.push({
        name: 'orderdetail',
        params: {order: this.order}
      })
    }
  }
}
</script>

<style lang="less">
.listitem{
    padding: 25px 0px;
    border-bottom: 1px solid #ddd;
    overflow: hidden;
    .left{
        float: left;
    }
    .right{
        margin-left: 230px;
        h2{
            font-size: 18px;
            .pay{
                font-size: 12px;
                color: red;
                margin-left: 45px;
                float: none;
            }
            .comment{
                font-size: 14px;
                float: right;
                margin-right: 15px;
            }
            .comment:hover{
                color: #f01400;
            }
        }
        .orderdate{
            padding: 15px 0px;
            color: #999;
            span{
                margin-right: 40px;
            }
        }
        .text {
            padding-top: 10px;
            color: #666;
            span{
                color: #f01400;
                margin-right: 15px;
            }
            .look{
                padding: 5px;
                float: right;
                border: 1px solid #f01400;
                margin-right: 10px;
                a{
                    color: #f01400;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/order/orderitem.vue